var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"state-container"},[(_vm.isLoading)?_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}}):(_vm.showNoData)?_c('span',[_vm._v(_vm._s(_vm.$t("message.common.noData")))]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }